import axios from "axios";

axios.defaults.timeout = 1200000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// http request 拦截器
axios.interceptors.request.use(config => {
        // const isToken = (config.headers || {}).isToken === false
        // if (Cookies.get('token') && !isToken) {
        //     config.headers['Authorization'] = 'Bearer ' + Cookies.get('token')
        // }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(res => {
        const code = res.data.code || 200;
        // 二进制数据则直接返回
        if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
            return res.data
        }
        if (code === 401) {
            console.log("报错了")
            return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        }else if (code === 500) {
            console.log("报错了", res.data.msg)
            return Promise.reject(new Error('系统异常'))
        }

        return res.data;
    },
    error => {
        return Promise.reject(error);
    }
);

export default axios;
